import EmptyCart from './empty-cart/empty-cart.vue';
import MarketOffer from './shared/market-offer.vue';
import RemoveItemModal from '../blocks/remove-item-modal/remove-item-modal.vue';
import ServletHelper from '../myAccount/helper/servlet-helper';
import PopulatedCart from './populated-cart/populated-cart.vue';
import ApiClient from '@/plugins/AxiosPlugin';
import LoadingDots from '@/dow-platform/components/commerce/shared/loading-dots/index.js';
import QuickAdd from './shared/quick-add.vue';
export default {
  name: 'PurchaseCart',
  components: {
    MarketOffer,
    EmptyCart,
    RemoveItemModal,
    PopulatedCart,
    LoadingDots,
    QuickAdd
  },
  data() {
    return {
      cartData: null,
      ShowModal: false,
      index: null,
      productDescription: '',
      product: [],
      loading: false,
      removeApiCallFailure: false,
      fetchApiCallFailure: false,
      productNumber: ''
    };
  },
  async created() {
    this.loading = true;
    try {
      this.cartData = await ServletHelper.makeServletCall(this.$store.state.settings.purchase_cart_servlet, '', {
        'Cache-Control': 'no-cache'
      });
    } catch (error) {
      this.fetchApiCallFailure = true;
      console.error('Error loading cart data:', error);
    } finally {
      this.loading = false;
    }
    //cart view tracking event
    this.trackCartView();
  },
  methods: {
    getI18nMessage: function (key) {
      return window.Granite.I18n.get(key);
    },
    toggleModal(payload) {
      this.ShowModal = payload.showModal;
      this.productDescription = payload.item?.myPartDescription ?? payload.item?.salesText ?? '';
      this.productNumber = payload.item?.myPartNumber ?? payload.item?.materialNumber ?? '';
      this.product = payload.item;
    },
    removeSingle() {
      this.loading = true;
      ApiClient.get(this.$store.state.settings.remove_cart_servlet, {
        params: {
          materialNumber: this.product.materialNumber,
          sapLineNumber: this.product.sapLineItemNumber
        },
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        this.updateCartCount();
        sessionStorage.setItem('itemRemoved', 'true');
        this.loading = false;
        window.location.reload();
      }.bind(this)).catch(error => {
        this.loading = false;
        this.removeApiCallFailure = true;
        console.error('Error with removing single item from cart', error);
      });
    },
    updateCartCount() {
      let header = document.querySelector(".cmp--header_container");
      header.classList.add('itemToHide');
      if (this.$store.state.user?.dccUserInfo?.data?.numberOfCartItems > 0) {
        this.$store.state.user.dccUserInfo.data.numberOfCartItems = -1;
      }
    },
    trackCartView() {
      const products = this.cartData?.cartData?.entries?.map(entry => ({
        gmid: entry.materialNumber,
        SKU: entry.materialNumber,
        name: entry.myPartDescription || entry.salesText,
        quantity: entry.displayQuantity || entry.quantity
      }));
      if (products) {
        this.$store.dispatch('pdp/cartViewTracking', {
          products,
          event: 'cart:view'
        });
      }
    },
    updateCartData(data) {
      this.cartData = data;
    }
  }
};